import { IconButton } from '@ardoq/button';
import { IconName } from '@ardoq/icons';
import { type I18nLocale, t } from '@ardoq/i18n';

type DrawerCloseButtonProps = {
  onClose: VoidFunction;
  i18nLocale?: I18nLocale;
};

export const DrawerCloseButton = ({
  onClose,
  i18nLocale = {},
}: DrawerCloseButtonProps) => {
  return (
    <IconButton
      iconName={IconName.CLOSE}
      onClick={onClose}
      label={t(i18nLocale, 'drawer:closeLabel', 'Close')}
    />
  );
};
